export const ILocalizationRepositoryType = Symbol('ILocalizationRepository');
